
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#000000',
    darken1: colors.purple.darken2,
  },
  success: {
    base: '#FF6100',
    darken1: colors.purple.darken2,
  },
  formiosecondary: '#B9CADD',
  anchor: '#1976d2',
  formiotitle: '#0099CC',
  light: '#FEFEFE'
}